import React from "react";
import { FormattedMessage } from "react-intl";

const ChargerCatalogMainTitle = () => {
     return (
       <div className="charger-catalog-main-title">
         <div className="container">
           <h1 className="text-center">
             <FormattedMessage
               id="chargingCatalogMainTitle"
               defaultMessage="Charge Your EV at Home"
               description="Charge Your EV at Home"
             />
           </h1>
           <div className="sub-column-container">
             <div className="sub-column">
               <FormattedMessage
                 id="chargingCatalogMainContent"
                 defaultMessage="Setting up a home charger is easier and more affordable than you think. Browse our catalog of home chargers, use the filters to find the right match, and view estimated prices after incentives.{break} Not ready to shop yet? Explore our helpful tools to learn more about home charging options. Have questions? Check out our {link}!"
                 values={{
                   break: (
                     <>
                       <br />
                       <br />
                     </>
                   ),
                   link: <a href="/faqs">FAQs</a>,
                 }}
               />
             </div>
             <div className="sub-column has-image"></div>
           </div>
         </div>
       </div>
     );
};

export default ChargerCatalogMainTitle;
